import React, { useContext, useEffect, useState } from 'react';

import { useHelpBundle } from '@plasma/ui.application.app';
import { useNavigate, useParams } from '@plasma/ui.application.router';
import notification from '@plasma/ui.feedback.notification';
import { useResourceBundle, useTranslation } from '@plasma/ui.utils.i18n';

import { PlantLayoutContext } from '../..';
import { apiUriCartDataHttp, apiUriDesignDrawingsHttp, apiUriRfqActionHttp } from '../../services/conf/apiConf';
import { fetchAllDataGetFromAppFile_byApiName, fetchAllDataGet_byApiName, fetchAllDataGet_byApiName_for_RFQ } from '../../services/gets/getdata';
import { sendAllDataPost_byApiNameAndData, sendAllFileByPost, pollForFile } from '../../services/posts/postdata';
import linkExceptions from '../../services/Utils/linkExceptions';
import shoppingCartColumns from '../../types/shoppingcartDatatype';
import translations from './i18n';
import { ShoppingCartProps } from './shopping-cart';
import help from './shopping-cart.help';

function useShoppingCartHook(props: ShoppingCartProps) {
  useResourceBundle(translations, undefined, 'dcd9e157-4a50-45db-bfba-f210789659ad');
  useHelpBundle(help);

  const plantLayoutFromMemory = useContext(PlantLayoutContext);

  const { t } = useTranslation();
  const navigate = useNavigate();
  const { lastPage, suffix, planName } = useParams();

  const [lineseqData, setLineSeqData] = React.useState([]);
  const [equipNameSet, setEquipNameSet] = useState([]);
  const [consumeSet, setConsumeSet] = useState([]);
  const [dataForColumns, setdataForColumns] = useState([]);
  const [columnNames, setcolumnNames] = useState(shoppingCartColumns());
  const [search, setSearch] = useState('');
  const [clickedRow, setClickedRow] = useState('');
  const [showModal, setshowModal] = useState(false);
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [selectedValue, setSelectedValue] = useState('');
  const [area, setArea] = useState([]);
  const [dataForModal, setDataForModal] = useState([]);
  const [gridQuantity, setGridQuantity] = useState<any[]>([]);
  const [zone, setZone] = useState([]);
  const [source, setSource] = useState([]);
  const [quantIndex, setQuantIndex] = useState();
  const [showCodeModal, setshowCodeModal] = useState(false);
  const [filtData, setFiltData] = useState<any[]>([]);
  const [usedProfilesForCode, setusedProfilesForCode] = useState([]);
  const [usedEquipmentsForCode, setusedEquipmentsForCode] = useState([]);
  const [descriptionForCode, setdescriptionForCode] = useState('');
  const [selectedEquipment, setselectedEquipment] = useState('');
  const [viewDrawing, setviewDrawing] = useState(false);
  const [codeModalTitle, setcodeModalTitle] = useState('');
  const [dataFromPlantLayout, setDataFromPlantLayout] = useState<any>([]);
  const [showRFQModal, setshowRFQModal] = useState(false);
  const [iFrameSrc, setIframeSrc] = useState('');
  const [iFrameSrcForCode, setiFrameSrcForCode] = useState('');
  const [pdfBlob, setPdfBlob] = useState<string>('');
  const [reportName, setreportName] = useState('');
  const [totalQuantity, settotalQuantity] = useState('');
  const [allGuidData, setallGuidData] = useState([]);
  const [allGuidDataForEquipment, setallGuidDataForEquipment] = useState([]);
  const [sendMailButtonLoading, setSendMailButtonLoading] = useState<boolean>(false);
  const [pageLoading, setPageLoading] = useState<boolean>(false);
  const [showSupplierInfoModal, setShowSupplierInfoModal] = useState(false);

  useEffect(() => {
    fetchInitialData();
    fetchInitialDataForPdf();
  }, [search]);

  const fetchInitialData = async () => {
    setPageLoading(true);
    await fetchAllDataGet_byApiName(`getItemInShoppingCart?itemCode=${search}`, apiUriCartDataHttp()).then((data) => {
      // 2. Map the data
      const formattedData = data.map((item: any) => ({
        ...item,
        itemcount: Math.ceil(item.itemcount)
      }));
      setdataForColumns(formattedData);
    })
      .catch((error) => {
        console.log('Failed to Fetch Items');
      });
    await fetchAllDataGet_byApiName('getItemInShoppingCartToEdit', apiUriCartDataHttp()).then((data) => {
      const formattedData = data.map((item: any) => ({
        ...item,
        itemcount: item.itemcount.toFixed(2)
      }));
      setDataForModal(formattedData);
    })
      .catch((error) => {
        console.log('failed to fetch');
      });
    // await fetchAllDataGet_byApiName('GetPlantLayout').then((response) => {
    //   setDataFromPlantLayout(response);
    // });
    setDataFromPlantLayout(plantLayoutFromMemory?.layoutData ?? []);
    setPageLoading(false);
  };

  const fetchInitialDataForPdf = () => {
    fetchAllDataGetFromAppFile_byApiName("GetConsumableItemDocumentGuid", apiUriDesignDrawingsHttp()).then((data) => {
      setallGuidData(data);
    }).catch((error) => {
      console.log("Failed to Fetch Data");
    });

    fetchAllDataGetFromAppFile_byApiName("GetEquipmentDocumentGuids", apiUriDesignDrawingsHttp()).then((data) => {
      setallGuidDataForEquipment(data);
    }).catch((error) => {
      console.log("Failed to Fetch Data");
    });
  };

  const handleConsumableCodeClick = (code) => {
    //console.log('Consumable code: ',code);
    if (dataFromPlantLayout && dataFromPlantLayout.length > 0) {
      const profilesForCode = dataFromPlantLayout
        ?.map((onedataFromPlantLayout) => {
          const filteredProfiles = onedataFromPlantLayout.consumables
            ?.filter((oneData) => oneData.consumablecodeext === code)
            ?.map((oneItem) => oneItem.productprofiles);
          return filteredProfiles;
        })
        ?.filter((item_loc) => item_loc?.length > 0);

      const nameForCode = dataFromPlantLayout
        ?.map((onedataFromPlantLayout) => {
          const filteredProfiles = onedataFromPlantLayout.consumables?.filter(
            (oneData) => oneData.consumablecodeext === code,
          );
          return filteredProfiles;
        })
        ?.filter((item_loc) => item_loc?.length > 0);

      const equipmentsForCode = dataFromPlantLayout
        ?.map((onedataFromPlantLayout) => {
          const filteredCode = onedataFromPlantLayout.consumables?.filter(
            (oneData) => oneData.consumablecodeext === code,
          );
          if (filteredCode && filteredCode.length > 0) {
            return onedataFromPlantLayout;
          }
        })
        ?.filter((item) => item !== undefined && item !== null);

      //console.log(nameForCode[0][0]);

      setdescriptionForCode(nameForCode[0][0]?.consumabledescription);
      setusedProfilesForCode(profilesForCode[0][0]);
      setusedEquipmentsForCode(equipmentsForCode);
      setshowCodeModal(true);
      setcodeModalTitle(code);
    }
  };

  //console.log(dataForModal);
  const handleSelection = (selectedRowIndex, selectedRowData, event, columnName) => {
    // setselection(true);
    if (event.target.textContent === selectedRowData.itemcode
      && event.target.tagName.toLowerCase() === 'div'
      && !linkExceptions.includes(event.target.textContent)
      && columnName.accessor === "itemcode") {
      handleConsumableCodeClick(selectedRowData.itemcode);
      setshowModal(false);
    }
    else if (event.target.textContent === selectedRowData.equipmentName
      && event.target.tagName.toLowerCase() === 'div'
      && !linkExceptions.includes(event.target.textContent)
      && columnName.accessor === "equipmentName") {

      const guidForSelectedEquipment: any = allGuidDataForEquipment?.find((item: any) => item.docfor === selectedRowData.drawingnumber?.replace(/\.\.\./g, '')?.trim());
      setselectedEquipment(selectedRowData?.drawingnumber?.replace(/\.\.\./g, '')?.trim());
      fetchAndSetIframeSourceForCode(guidForSelectedEquipment ? guidForSelectedEquipment?.guid[0] : null, 'GetEquipmentDesign', apiUriDesignDrawingsHttp());
      setshowModal(false);
    }
    else {
      setshowModal(true);
    }

    setClickedRow(selectedRowData.itemcode);
  };

  const HandleModalCancel = () => {
    fetchAllDataGet_byApiName('getItemInShoppingCartToEdit', apiUriCartDataHttp())
      .then((data) => {
        const formattedData = data.map((item: any) => ({
          ...item,
          itemcount: item.itemcount.toFixed(2)
        }));
        setDataForModal(formattedData);
      })
      .catch((error) => {
        console.log('failed to fetch');
      });
    setshowModal(false);
    setSelectedValue('');
    setClickedRow('');
  };

  const handleGoHome = () => {
    navigate('/home-screen');
  };

  const dropdownArr = [];
  const dropQuant = [];
  const equipname = [];
  const lineSequence = [];
  const consumableName = [];
  const areaArr = [];
  const zoneArr = [];
  const sourceArr = [];

  useEffect(() => {
    dataForModal.filter((data: any) => {
      if (data?.itemcode === clickedRow) {
        lineSequence.push(data.lineseq);
        dropdownArr.push(data.productType + '-' + data.productDescription);
        dropQuant.push(data.itemcount);
        equipname.push(data.equipmentName);
        consumableName.push(data.consumableName);
        areaArr.push(data.areaName);
        zoneArr.push(data.zoneName);
        sourceArr.push(data.source);
      }
    });

    setLineSeqData(lineSequence);
    setGridQuantity(dropQuant);
    setEquipNameSet(equipname);

    setDropdownOptions(dropdownArr);
    setConsumeSet(consumableName);
    setArea(areaArr);
    setZone(zoneArr);
    setSource(sourceArr);

    const filteredData = dataForModal.filter((item) => item.itemcode === clickedRow);


    setFiltData(filteredData);

    const totalItemCount = dataForColumns.reduce((sum, item) => sum + Number(item.itemcount), 0);
    settotalQuantity(totalItemCount.toFixed(2).toString());

  }, [clickedRow, dataForModal]);

  const handleUp = (index: number, newQuantity: number) => {
    // Enforce exactly two decimal places and convert back to a clean number
    const sanitizedQuantity = parseFloat(newQuantity.toFixed(2));

    const updatedGridQuantity = [...gridQuantity];
    updatedGridQuantity[index] = sanitizedQuantity;

    setGridQuantity(updatedGridQuantity);

    const updatedData = filtData.map((item, i) => ({
      ...item,
      itemcount: i === index ? sanitizedQuantity : item.itemcount,
    }));
    setFiltData(updatedData);
  };

  const handleDown = (index: number, newQuantity: number) => {
    // Enforce exactly 2 decimal places on the incoming calculation
    let actualQuantity = parseFloat(newQuantity.toFixed(2));

    if (actualQuantity < 0) {
      actualQuantity = 0;
    }

    const updatedGridQuantity = [...gridQuantity];
    updatedGridQuantity[index] = actualQuantity;
    setGridQuantity(updatedGridQuantity);

    const updatedData = filtData.map((item, i) => ({
      ...item,
      itemcount: i === index ? actualQuantity : item.itemcount,
    }));
    setFiltData(updatedData);
  };

  const HandleCodeModalCancel = () => {
    setusedProfilesForCode([]);
    setusedEquipmentsForCode([]);
    setshowCodeModal(false);
    setcodeModalTitle('');
  };

  const handleDeleteLine = (index: number) => {
    const updatedGridQuantity = [...gridQuantity];
    updatedGridQuantity[index] = 0;
    setGridQuantity(updatedGridQuantity);

    if (index >= 0 && index < filtData.length) {
      filtData[index].itemcount = 0;
    }
    // console.log('delete click1: ', filtData);
  };
  // console.log('delete click2: ', filtData);

  const handleRemoveAll = () => {
    const removedData = filtData.map(item => ({
      ...item,
      itemcount: 0
    }));

    sendAllDataPost_byApiNameAndData('PostItemInShoppingCartConsumableUtilization', removedData, apiUriCartDataHttp())
      .then((data) => {
        fetchInitialData();
        notification.success('Removed !', 'Item removed from cart', undefined, 'medium', 3)
        setshowModal(false);
      })
      .catch((error) => {
        console.log(error);
        notification.error('Error !', 'Unsuccessful Attempt', undefined, 'medium', 3)
      });
  };

  const handleOk = () => {
    sendAllDataPost_byApiNameAndData('PostItemInShoppingCartConsumableUtilization', filtData, apiUriCartDataHttp())
      .then((data) => {
        fetchInitialData();
        notification.success('Saved !', 'Items saved successfully', undefined, 'medium', 3)
        setshowModal(false);
      })
      .catch((error) => {
        console.log(error);
        notification.error('Error !', 'Unsuccessful Attempt', undefined, 'medium', 3)
      });
    setshowModal(false);
  };

  async function fetchAndSetIframeSourceForCode(guId: string, apiName: string, baseUri?: string) {
    const queryParams = new URLSearchParams({
      guid: guId
    });
    try {
      const blob: any = await pollForFile(`${apiName}?${queryParams}`, {}, undefined, undefined, baseUri);
      const blobUrl = URL.createObjectURL(blob);
      setiFrameSrcForCode(blobUrl);
      setviewDrawing(true);
      return true
    } catch (error) {
      notification.error('Error !', 'Unsuccessful Attempt', undefined, 'medium', 3);
      return false;
    }
  };

  const handleDrawingModal = () => {
    const guidForSelectedCode: any = allGuidData?.find((item: any) => item.docfor === codeModalTitle);
    // console.log('click: ', guidForSelectedCode);
    fetchAndSetIframeSourceForCode(guidForSelectedCode ? guidForSelectedCode.guid[0] : null, 'getConsumableItemDesign', apiUriDesignDrawingsHttp())
  };

  const handleDrawingModalCancel = () => {
    setIframeSrc('');
    setiFrameSrcForCode('');
    setselectedEquipment('');
    setviewDrawing(false);
  };

  const handleGenerateRFQ = async () => {
    notification.info('', "Waiting for File...", undefined, 'medium', 1);
    setPageLoading(true);
    await fetchAllDataGet_byApiName_for_RFQ('GenerateRfqReport', apiUriRfqActionHttp())
      .then(({ headers, data }) => {
        // Access the Content-Disposition header
        const contentDisposition = headers.get('Content-Disposition');
        let filename = 'default_filename.pdf';

        if (contentDisposition) {
          // Improved regex to match different filename formats
          const matches = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, ''); // Remove any surrounding quotes
          }
        }
        setreportName(filename);
        setIframeSrc(data);
        setPdfBlob(data);
      })
      .catch((error) => {
        console.log('Failed to Fetch Data:', error);
        notification.error('Error!', 'Unsuccessful Attempt', undefined, 'medium', 2);
      });
    setPageLoading(false);
  };

  useEffect(() => {
    if (iFrameSrc) {
      setshowRFQModal(true);
    }
  }, [iFrameSrc]);

  // Function to convert base64 to Blob
  const base64toBlob = (base64Data: string): Blob => {
    const binaryString = window.atob(base64Data.split(',')[1]);
    const byteArray = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      byteArray[i] = binaryString.charCodeAt(i);
    }
    return new Blob([byteArray], { type: 'application/pdf' });
  };

  const handleRFQSend = () => {
    setSendMailButtonLoading(true);
    const rfqActionParam = {
      status: 'sendmail',
      rfqCode: reportName.replace('.pdf', '').replace(/-/g, '/')
    };

    const rfqActionParamtToCancel = {
      status: 'cancel',
      rfqCode: reportName.replace('.pdf', '').replace(/-/g, '/')
    };

    const blob = base64toBlob(pdfBlob);
    const formData = new FormData();
    formData.append('File', blob, reportName); // 'pdfFile' is the field name for the file
    formData.append('base64BinaryStr', '');

    sendAllFileByPost('sendEmail', formData).then((response) => {
      if (response.code === '0') {
        notification.success(response.message, response.responseData);
        sendAllDataPost_byApiNameAndData('HandleRfqAction', rfqActionParam, apiUriRfqActionHttp()).then((data) => {
          fetchInitialData();
          setIframeSrc('');
          setSendMailButtonLoading(false);
          setshowRFQModal(false);
        })
          .catch((error) => {
            console.log(error);
          });
      }
      else {
        notification.error(response.message, response.responseData);
        sendAllDataPost_byApiNameAndData('HandleRfqAction', rfqActionParamtToCancel, apiUriRfqActionHttp()).then((data) => {
          fetchInitialData();
          setIframeSrc('');
          setSendMailButtonLoading(false);
          setshowRFQModal(false);
        })
          .catch((error) => {
            console.log(error);
          });
      }
    }).catch((error) => {
      console.log(error);
      setSendMailButtonLoading(false);
      notification.error('Error !', 'Unsuccessful Attempt', undefined, 'medium', 2)
    });
  };

  const handleRFQModalCancel = () => {
    const rfqActionParam = {
      status: 'sendmail',
      rfqCode: reportName.replace('.pdf', '').replace(/-/g, '/')
    };

    sendAllDataPost_byApiNameAndData('HandleRfqAction', rfqActionParam, apiUriRfqActionHttp()).then((data) => {
      notification.success('Successful...', 'RFQ saved successfully!')
      fetchInitialData();
    })
      .catch((error) => {
        console.log(error);
      });

    setIframeSrc('');
    setSendMailButtonLoading(false);
    setshowRFQModal(false);
  };

  const justCloseRfqModal = () => {
    setIframeSrc('');
    setSendMailButtonLoading(false);
    setshowRFQModal(false);
  }

  const handleRFQModalDelete = () => {
    const rfqActionParam = {
      status: 'delete',
      rfqCode: reportName.replace('.pdf', '').replace(/-/g, '/')
    };

    sendAllDataPost_byApiNameAndData('HandleRfqAction', rfqActionParam, apiUriRfqActionHttp()).then((data) => {
      fetchInitialData();
    })
      .catch((error) => {
        console.log(error);
      });

    setIframeSrc('');
    setshowRFQModal(false);
  };

  const handleSupplierInfoModal = () => {
    setShowSupplierInfoModal(true);
  }

  const handleSupplierInfoModalCancel = () => {
    setShowSupplierInfoModal(false);
  }

  const handleGoBack = () => {
    switch (lastPage) {
      case '0':
        navigate('/home-screen');
        break;
      case 'overview':
        navigate('/home-screen');
        navigate('/consumable-overview');
        break;
      default:
        navigate(`/planned-demand-page/${lastPage}/${suffix}/${planName}`);
        break;
    }
  }

  return {
    t,
    dataForColumns,
    columnNames,
    handleGoHome,
    search,
    setSearch,
    clickedRow,
    setClickedRow,
    showModal,
    setshowModal,
    handleSelection,
    HandleModalCancel,
    dropdownOptions,
    lineseqData,
    selectedValue,
    area,
    zone,
    source,
    handleOk,
    gridQuantity,
    setGridQuantity,
    equipNameSet,
    consumeSet,
    setQuantIndex,
    quantIndex,
    viewDrawing,
    handleDrawingModal,
    handleDrawingModalCancel,
    handleUp,
    handleDown,
    showCodeModal,
    setshowCodeModal,
    HandleCodeModalCancel,
    handleGenerateRFQ,
    handleRFQSend,
    handleRFQModalCancel,
    handleRFQModalDelete,
    handleRemoveAll,
    handleDeleteLine,
    handleGoBack,
    showRFQModal,
    codeModalTitle,
    descriptionForCode,
    usedEquipmentsForCode,
    usedProfilesForCode,
    iFrameSrc,
    totalQuantity,
    dataForModal,
    iFrameSrcForCode,
    selectedEquipment,
    sendMailButtonLoading,
    lastPage,
    pageLoading,
    handleSupplierInfoModal,
    handleSupplierInfoModalCancel,
    showSupplierInfoModal,
    justCloseRfqModal
  };
}

export default useShoppingCartHook;

